import { render, staticRenderFns } from "./ConsentAdvertising.vue?vue&type=template&id=2f436dd4&scoped=true&"
import script from "./ConsentAdvertising.vue?vue&type=script&lang=ts&"
export * from "./ConsentAdvertising.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentAdvertising.vue?vue&type=style&index=0&id=2f436dd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f436dd4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseClickedCheckbox: require('/usr/www/nuxt/components/Base/BaseClickedCheckbox.vue').default})
